var $82eacc9a6cad8168$exports = {};
$82eacc9a6cad8168$exports = {
    "Clear search": `Zoekactie wissen`
};


export {$82eacc9a6cad8168$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
